var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "450 250 450 300",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "visto_svg__st0",
    d: "M491.7 396.7l41.6 94.1c2.4 5.5 7.7 9.3 13.6 9.9 6 .6 11.9-2 15.4-6.9l144.8-200.2c5.5-7.5 3.8-18.1-3.8-23.5-7.5-5.5-18.1-3.8-23.5 3.8L552.2 450.4l-29.7-67.3c-3.8-8.5-13.7-12.4-22.2-8.6-8.5 3.8-12.4 13.7-8.6 22.2zM657.2 396.7l41.6 94.1c2.4 5.5 7.7 9.3 13.6 9.9 6 .6 11.9-2 15.4-6.9l144.8-200.2c5.5-7.5 3.8-18.1-3.8-23.5-7.5-5.5-18.1-3.8-23.5 3.8L717.7 450.4 688 383.1c-3.8-8.5-13.7-12.4-22.2-8.6-8.5 3.8-12.4 13.7-8.6 22.2z"
  })));
}

export default SvgVisto;